<footer class="footer d-flex flex-column align-items-center justify-content-center">
  <img class="logo"
    role="presentation"
    src="assets/img/logo_footer.svg"
    alt="Markwins Beauty Brands icon logo" />

  <div class="container">
    <div class="row">
      <div class="col-24 footer-container">
        <!-- About -->
        <li class="footer-menu-title">
          <a tabindex="0"
            target="_self">
            About </a>

          <ul class="footer-list">
            <li class="items-of-list">
              <a tabindex="0"
                class="footer-menu-link"
                [routerLink]="['about','who-we-are']"
                target="_self">
                Who We Are </a>
            </li>
            <li class="items-of-list">
              <a tabindex="0"
                class="footer-menu-link"
                [routerLink]="['about','our-global-footprint']"
                target="_self">
                Our Global Footprint </a>
            </li>
            <li class="items-of-list">
              <a tabindex="0"
                class="footer-menu-link"
                [routerLink]="['about','culture-values']"
                target="_self">
                Culture &amp; Values </a>
            </li>
          </ul>
        </li>
        <!-- Brands -->
        <li class="w-100 footer-menu-title">
          <a tabindex="0"
            [routerLink]="['/our-brands']"
            target="_self">
            Our Brands </a>
          <ul class="footer-list">
            <li class="items-of-list"
              *ngFor="let brand of storeService.store.brands">
              <a class="footer-menu-link"
                [routerLink]="['brand', brand.name, brand.id]">
                {{brand.name}}
              </a>
            </li>
          </ul>
        </li>

        <!-- Contact Us -->
        <li class="footer-menu-title">
          <a tabindex="0">
            Follow Us </a>
          <ul class="footer-list">
            <li class="items-of-list">
              <ul class="social list-unstyled d-flex">
                <li class="pr-3">
                  <a [href]="configs.social.tiktok"
                    tabindex="0"
                    target="_self"
                    aria-label="Visit our TikTok page">
                    <fa-icon [icon]="['fab', 'tiktok']"
                      size="lg"></fa-icon>
                  </a>
                </li>
                <li class="pr-3">
                  <a [href]="configs.social.instagram"
                    tabindex="0"
                    target="_self"
                    aria-label="Visit our Instagram page">
                    <fa-icon [icon]="['fab', 'instagram']"
                      size="lg"></fa-icon>
                  </a>
                </li>
                <li>
                  <a [href]="configs.social.facebook"
                    tabindex="0"
                    target="_self"
                    aria-label="Visit our Facebook page">
                    <fa-icon [icon]="['fab', 'facebook']"
                      size="lg"></fa-icon>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>

        <!-- Accessibility Link -->
        <li>
          <a tabindex="0">
            Accessibility</a>
          <ul class="footer-list">

            <li class="items-of-list">
              <a href="assets/pdf/accessibility/[ita]_Accessibility Statement-https___www.markwins.eu___.pdf"
                class="footer-menu-link"
                tabindex="0"
                target="_blank">
                Accessibility Statement – IT</a>
            </li>

            <li>
              <a href="assets/pdf/accessibility/[eng]_Accessibility Statement-https___www.markwins.eu___.pdf"
                class="footer-menu-link"
                tabindex="0"
                target="_blank">
                Accessibility Statement – EN</a>
            </li>
          </ul>
        </li>

      </div>
    </div>
  </div>




  <span class="footer text-center text-white mt-3">
    MARKWINS BEAUTY BRANDS INTERNATIONAL Ltd
  </span>
  <span class="footer text-center text-white">
    Registered Office: c/o RSM UK Tax and Accounting Limited 22 - 25 Farringdon Street, London EC4A 4AB,
    UK
  </span>
  <span class="footer text-center text-white">
    VAT No: GB 745 1590 28
  </span>
  <span class="footer text-center text-white">
    <a href="mailto:info@markwins.eu"
      class="text-white email-link">info&#64;markwins.eu</a>
  </span>
  <ul class="list-unstyled text-center text-white mt-3 mb-3 d-flex flex-wrap justify-content-center">
    <li class="mr-2">
      <a href="https://www.iubenda.com/privacy-policy/{{selectedPrivacyData?.id}}"
        class="iubenda-white no-brand iubenda-noiframe iubenda-embed iubenda-noiframe "
        [title]="selectedPrivacyData?.title">{{selectedPrivacyData?.title}}</a>
    </li>
    <li>
      <a href="https://www.iubenda.com/privacy-policy/39692961/cookie-policy"
        class="iubenda-white no-brand iubenda-noiframe iubenda-embed iubenda-noiframe"
        [title]="selectedPrivacyData?.cookieTitle ">{{selectedPrivacyData?.cookieTitle}}</a>
    </li>
  </ul>
</footer>